var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0725 17.6029H28.7312L30.5892 8.66478L30.6479 8.03892C30.6479 7.23703 30.3154 6.49381 29.7873 5.96573L27.7141 3.91211L14.8448 16.8011C14.1211 17.5052 13.6908 18.4831 13.6908 19.5588V39.1171C13.6908 41.2685 15.4511 43.0288 17.6025 43.0288H35.205C36.8283 43.0288 38.217 42.0509 38.8037 40.6427L44.7103 26.854C44.8863 26.4042 44.9841 25.9348 44.9841 25.4263V21.5146C44.9841 19.3632 43.2239 17.6029 41.0725 17.6029ZM41.0725 25.4263L35.205 39.1171H17.6025V19.5588L26.0908 11.0705L23.9198 21.5146H41.0725V25.4263ZM9.77914 19.5588H1.95581V43.0288H9.77914V19.5588Z",
    fill: "white",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLike);
export default __webpack_public_path__ + "static/media/icon-like.299fc658a52014d2ddc4bdb1240a701f.svg";
export { ForwardRef as ReactComponent };